<div class="container" style="padding: 16px;">
  <mat-grid-list cols="{{ ( cardLayout | async )?.columns }}" rowHeight="200px">
    <mat-grid-tile [colspan]="( cardLayout | async )?.miniCard.cols" [rowspan]="( cardLayout | async )?.miniCard.rows">
      <mat-card *ngIf="isloaded" class= mat-elevation-z5 appTempColor>
        <mat-card-title class="tempText">Temperature</mat-card-title>
        <app-temperature [temp]="temp"></app-temperature>
      </mat-card>
    </mat-grid-tile>
    <mat-grid-tile [colspan]="( cardLayout | async )?.miniCard.cols" [rowspan]="( cardLayout | async )?.miniCard.rows">
      <mat-card *ngIf="isloaded" class="mat-elevation-z5" appHeatIndex>
        <mat-card-title *ngIf="temp>50">Heat Index</mat-card-title>
        <mat-card-title *ngIf="temp<=50">Wind Chill</mat-card-title>
        <app-heat-index [heatIndex]="heatIndex" [windChill]="windChill" [temp]="temp"></app-heat-index>
      </mat-card>
    </mat-grid-tile>
    <!-- <mat-grid-tile [colspan]="( cardLayout | async )?.miniCard.cols" [rowspan]="( cardLayout | async )?.miniCard.rows">
      <mat-card class="mat-elevation-z5">
        <mat-card-title>Dew Point</mat-card-title>
        <app-dew-point [dewPoint]="dewPoint"></app-dew-point>
      </mat-card>
    </mat-grid-tile> -->
    <mat-grid-tile [colspan]="( cardLayout | async )?.miniCard.cols" [rowspan]="( cardLayout | async )?.miniCard.rows">
      <mat-card *ngIf="isloaded" class="mat-elevation-z5" appWindSpeedColor>
        <mat-card-title>Wind Speed & Direction</mat-card-title>
        <app-wind-rose [direction]="windDirection"></app-wind-rose>
      </mat-card>
    </mat-grid-tile>
    <mat-grid-tile [colspan]="( cardLayout | async )?.miniCard.cols" [rowspan]="( cardLayout | async )?.miniCard.rows">
      <mat-card *ngIf="isloaded" class="mat-elevation-z5" appSolarColors>
        <mat-card-title>Solar Radiation</mat-card-title>
        <app-solar-radiation [solarRad]="solarRad"></app-solar-radiation>
      </mat-card>
    </mat-grid-tile>
    <mat-grid-tile [colspan]="( cardLayout | async )?.miniCard.cols" [rowspan]="( cardLayout | async )?.miniCard.rows">
      <mat-card *ngIf="isloaded" class="mat-elevation-z5" appRainColor>
        <mat-card-title>Total Daily Rain</mat-card-title>
        <app-total-daily-rain [rain]="dailyRain"></app-total-daily-rain >
      </mat-card>
    </mat-grid-tile>
    <mat-grid-tile [colspan]="( cardLayout | async )?.miniCard.cols" [rowspan]="( cardLayout | async )?.miniCard.rows">
      <mat-card *ngIf="isloaded" class="mat-elevation-z5" appHumidityColor>
        <mat-card-title>Humidity</mat-card-title>
        <app-humidity *ngIf="isloaded" [humidity]="humidity" [dewPoint]="dewPoint"></app-humidity>
      </mat-card>
    </mat-grid-tile>
    <mat-grid-tile [colspan]="( cardLayout | async )?.forecast.cols" [rowspan]="( cardLayout | async )?.forecast.rows">
      <mat-card class="mat-elevation-z5">
        <mat-card-title>Forecast</mat-card-title>
        <app-forecast [forecast]="forecastData"></app-forecast>
      </mat-card>
    </mat-grid-tile>
    <mat-grid-tile [colspan]="( cardLayout | async )?.chart.cols" [rowspan]="( cardLayout | async )?.chart.rows">
      <mat-card class="mat-elevation-z5">
        <app-pressure></app-pressure>
      </mat-card>
    </mat-grid-tile>
    <mat-grid-tile [colspan]="( cardLayout | async )?.miniCard.cols" [rowspan]="( cardLayout | async )?.miniCard.rows">
      <mat-card class="mat-elevation-z5">
        <mat-card-title>Contact Information</mat-card-title>
        <p style="font-size: 15px;">
          <a href = "mailto: fryej@uww.edu">John Frye</a><br/>
          Associate Professor <br />  
          Phone: 262-472-5270 <br />  
          Location: Upham 116 <br />  
        </p>
        <p style="float:right">{{fullDate}}</p>
      </mat-card>
    </mat-grid-tile>
  </mat-grid-list>
  <!-- <div style="margin-left: 16px;">
    <p style="font-size: 22px;">Contact Information</p>
    <p style="font-size: 15px;">
      <a href = "mailto: fryej@uww.edu">John Frye</a><br/>
      Associate Professor <br />  
      Phone: 262-472-5270 <br />  
      Location: Upham 116 <br />  
    </p>
  </div> -->
</div>